import { render, staticRenderFns } from "./teachersAdvantage.vue?vue&type=template&id=6ddc76e0&"
import script from "./teachersAdvantage.vue?vue&type=script&lang=js&"
export * from "./teachersAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports